import { supabase } from './supabase';

/**
 * Service d'administration des restos (super admin) :
 * - supprimer un resto (RPC `delete_tenant`, SECURITY DEFINER super_admin, cf. sql/32),
 * - créer un resto manuellement (Edge Function `create-tenant` → provision).
 */

export interface MutationResult {
  ok: boolean;
  error?: string;
}

/** Supprime définitivement un resto + ses données (réservé super_admin). */
export async function deleteTenant(tenantId: string): Promise<MutationResult> {
  const { error } = await supabase.rpc('delete_tenant', { p_tenant_id: tenantId });
  if (error) return { ok: false, error: `Suppression impossible : ${error.message}` };
  return { ok: true };
}

export interface CreateTenantInput {
  name: string;
  slug: string;
  email: string;
  country?: 'fr' | 'ch' | 'be';
}

export interface CreateTenantResult {
  ok: boolean;
  tenantId?: string;
  sitePath?: string;
  adminPath?: string;
  email?: string;
  tempPassword?: string;
  emailSent?: boolean;
  error?: string;
}

/** Crée un resto manuellement (site + email de bienvenue) via l'Edge Function sécurisée. */
export async function createTenant(input: CreateTenantInput): Promise<CreateTenantResult> {
  const { data, error } = await supabase.functions.invoke('create-tenant', {
    body: { name: input.name, slug: input.slug, email: input.email, country: input.country ?? 'fr' },
  });
  if (error) return { ok: false, error: error.message };
  const res = (data ?? {}) as CreateTenantResult;
  if (!res.ok) return { ok: false, error: res.error ?? 'Création impossible.' };
  return res;
}
